/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import './style.css';
import { FormControl, InputAdornment, OutlinedInput, Popover } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useSelector } from 'react-redux';

interface DurationFieldProps {
    defaultDuration?: string;
    HandleDuration: (val:any) => void;
    callFunc: boolean
}

const DurationField = forwardRef((props:DurationFieldProps, ref) =>
{
	const { defaultDuration, HandleDuration, callFunc } = props;
	const userData = useSelector((state: any) => state.mysession.session);
	const allocatedDuration = userData?.companyData?.meetingManagement?.sessionTime;

	const calculatedDur = (duration: number) =>
	{
		if (duration < 60)
		{
			return { hours: '00', minutes: duration.toString().padStart(2, '0') };
		}
		const hours = Math.floor(duration / 60).toString()
			.padStart(2, '0');
		const remainingMinutes = (duration % 60).toString().padStart(2, '0');

		return { hours, minutes: remainingMinutes };
	};

	const { hours: initialHours, minutes: initialMinutes } = calculatedDur(Number(defaultDuration) || 0);

	const [ hours, setHours ] = useState(initialHours);
	const [ minutes, setMinutes ] = useState(initialMinutes);
	const [ duration, setDuration ] = useState<number>(Number(defaultDuration) || 0);
	const [ anchorEl, setAnchorEl ] = useState(null);

	const handleChange = (val: string, num: number) =>

	{
		if (num === 0)
		{
			const hr: any = parseInt(val);
			const newD: any = hr * 60 + parseInt(minutes);

			setHours(val);
			setDuration(newD);
			if (callFunc)
			{
				HandleDuration(newD);
			}
		}
		else
		{
			const hrs: any = parseInt(hours);

			const newDuration: any = parseInt(val) + hrs * 60;

			setMinutes(val);
			setDuration(newDuration);
			if (callFunc)
			{
				HandleDuration(newDuration);
			}
		}
	};

	// Convert allocatedDuration from minutes to hours and generate hourOptions dynamically
	const generateHourOptions = () =>
	{
		if (!allocatedDuration || allocatedDuration <= 0)
		{
			// Default fallback if no allocatedDuration is provided
			return [ '00' ];
		}

		// Convert minutes to hours (rounded up to include partial hours)
		const maxHours = Math.ceil(allocatedDuration / 60);

		// Generate array from '00' to maxHours
		const options: string[] = [];

		for (let i = 0; i <= maxHours; i++)
		{
			options.push(i.toString().padStart(2, '0'));
		}

		return options;
	};

	const hourOptions = generateHourOptions();

	const minuteOptions = [ '00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55' ];

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () =>
	{
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	// Function to format the duration string
	const formatDuration = (hr, min) =>
	{
		const hrs = parseInt(hr);
		const mins = parseInt(min);

		if (hrs === 0)
		{
			return `${mins} mins`;
		}
		else if (mins === 0)
		{
			return `${hrs} hr${hrs > 1 ? 's' : ''}`;
		}
		else
		{
			return `${hrs} hr${hrs > 1 ? 's' : ''} ${mins} mins`;
		}
	};

	const durationString = formatDuration(hours, minutes);

	useImperativeHandle(ref, () => (duration), [ duration ]);

	return (
		<>
			<FormControl fullWidth variant='outlined' size='small' margin='dense' aria-describedby={id}>
				<OutlinedInput
					id='outlined-adornment-weight'
					endAdornment={<InputAdornment position='end'><AccessTimeIcon onClick={handleClick} className='pointer' /></InputAdornment>}
					aria-describedby='outlined-weight-helper-text'
					inputProps={{
						'aria-label' : 'weight'
					}}
					value={durationString}
				/>
			</FormControl>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical   : 'bottom',
					horizontal : 'center'
				}}
				transformOrigin={{
					vertical   : 'bottom',
					horizontal : 'right'
				}}
			>
				<div className='dropdowns'>
					<div className='column'>
						<ul className='options textCntr'>
							<li className='fontWeightMD posSticky'>Hours</li>
							{hourOptions.map((hour) => (
								<li id='hours' key={hour} onClick={() => handleChange(hour, 0)} className={hour === hours ? 'selected' : ''}>{hour}</li>
							))}
						</ul>
					</div>
					<div className='column'>
						<ul className='options textCntr'>
							<li className='fontWeightMD posSticky'>Mins</li>
							{minuteOptions.map((minute) => (
								<li id='minutes' key={minute} onClick={() => handleChange(minute, 1)} className={minute === minutes ? 'selected' : ''}>{minute}</li>
							))}
						</ul>
					</div>
				</div>
			</Popover>
		</>
	);
});

DurationField.displayName = 'DurationField';

export default DurationField;